import envConst from '../env-const.js'
export default function(){
  let jsList = [
    '/editor/neditor.config.js',
    '/editor/neditor.all.js'
  ]
  for(let i in jsList){
    let _path = envConst.API_BASE_URL + jsList[i]
    // if(window.CMSC_VERSION&&window.CMSC_VERSION.scmcc_ui){
    //   _path = `${_path}?${window.CMSC_VERSION.scmcc_ui}`
    // }
    let loadScriptEl = document.createElement('script')
    loadScriptEl.src = _path
    document.body.appendChild(loadScriptEl)
  }
}